import {
  IAgente,
  IAgentePost,
  IAgenteUpdate,
} from '../../core/interfaces/agents.interface';

export class GetAllAgentsAction {
  static readonly type = '[Agents] Get All';
  constructor() {}
}

export class GetAgentByUuidAction {
  static readonly type = '[Agents] Get By UUID';
  constructor(public payload: string) {}
}

export class CreateAgentAction {
  static readonly type = '[Agents] Create';
  constructor(public payload: IAgentePost) {}
}

export class UpdateAgentAction {
  static readonly type = '[Agents] Update';
  constructor(public payload: { uuid: string; data: IAgenteUpdate }) {}
}

export class DeleteAgentAction {
  static readonly type = '[Agents] Delete';
  constructor(public payload: string) {}
}

